export default (httpClient) => ({
  save: async ({ dia, marketplace, hora, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.post(
      "/horario",
      {
        dia,
        marketplace,
        hora,
      },
      {
        headers,
      }
    );
    return {
      data: response.data,
    };
  },

  delete: async ({ id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.delete(`/horario/${id}`, {
      headers,
    });
    return {
      data: response.data,
    };
  },

  update: async ({ id, dia, marketplace, hora, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.put(
      `/horario/${id}`,
      {
        dia,
        marketplace,
        hora,
      },
      {
        headers,
      }
    );
    return {
      data: response.data,
    };
  },

  getAll: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/horario", {
      headers,
    });
    return {
      data: response.data,
    };
  },

  getById: async ({ id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get(`/horario/${id}`, {
      headers,
    });
    return {
      data: response.data,
    };
  },
});
